
export enum WorkflowSelectionModeCd {
	LIST = 'List',
	TOP_OF_STACK = 'TopOfStack'}

